export default __webpack_public_path__ + "static/media/cadeaux-7.83d87696.jpeg";